var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "max-content" }, [
    _vm.getUser.userType === "1"
      ? _c("div", { staticClass: "content-wrapper" }, [
          _c(
            "ul",
            { staticStyle: { "list-style": "decimal", padding: "0 20px" } },
            [
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip1")),
                },
              }),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip2")),
                },
              }),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip3")),
                },
              }),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip4")),
                },
              }),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip5")),
                },
              }),
              _vm.$i18n.locale == "en"
                ? _c("li", [
                    _vm._v(
                      "\n                For large groups with thousands of PBC line items, consider setting up multiple KCC sites (contact\n                "
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#1e49e2",
                          "text-decoration": "underline",
                        },
                        on: { click: _vm.openEmail },
                      },
                      [_vm._v("KCC Team")]
                    ),
                    _vm._v(" to seek support)\n            "),
                  ])
                : _c("li", [
                    _vm._v(
                      "\n                对于拥有数千条PBC需求条目的大型集团项目，请考虑创建多个KCC站点进行管理（请联系"
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#1e49e2",
                          "text-decoration": "underline",
                        },
                        on: { click: _vm.openEmail },
                      },
                      [_vm._v("KCC团队")]
                    ),
                    _vm._v("获取帮助）\n            "),
                  ]),
              _c("li", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("kcc_max_speed_kp_tip7")) +
                    "\n                "
                ),
                _c(
                  "ul",
                  { staticStyle: { "list-style": "disc", padding: "0 20px" } },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip7_1")),
                      },
                    }),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip7_2")),
                      },
                    }),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("kcc_max_speed_kp_tip7_3")),
                      },
                    }),
                  ]
                ),
              ]),
            ]
          ),
        ])
      : _c("div", { staticClass: "content-wrapper" }, [
          _c(
            "ul",
            { staticStyle: { "list-style": "decimal", padding: "0 20px" } },
            [
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_client_tip1")),
                },
              }),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_client_tip2")),
                },
              }),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_client_tip3")),
                },
              }),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("kcc_max_speed_client_tip4")),
                },
              }),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }